module.exports = __webpack_public_path__ + "img/Salaire-FGA-CFDT_qrcode.e61313b8.svg";